<template>
    <md-dialog :md-active.sync="active" :md-close-on-esc="false"
    :md-click-outside-to-close="false"
    :class="{'custom-padding': padding}" :data-notif-id="values.notif_id">
        <md-dialog-title>{{i18n.lbl_limit_s()}}</md-dialog-title>
        <detail :prop="i18n.lbl_wallet()"  :value="values.wallet" :copiable="true"/>
        <detail :prop="i18n.lbl_asset()"  :value="values.asset"/>
        <!-- <detail v-if="values.order_uuid" :prop="i18n.lbl_order_uid()"  :value="values.order_uuid" :copiable="true"/> -->
        <detail v-if="values.amount" :prop="i18n.lbl_amount()"  :value="amount"/>
        <detail v-if="values.order_no" :prop="i18n.lbl_order_id()"  :value="values.order_no" :copiable="true"/>
        <detail v-if="values.order_amount" :prop="i18n.lbl_order_amount()"  :value="orderAmount"/>
        <detail v-if="values.order_network" :prop="i18n.lbl_order_network()" :value="values.order_network"/>
        <detail v-if="values.timeStamp" :prop="i18n.lbl_time_optional()"  :value="values.timeStamp"/>
        <md-dialog-actions>
        <md-button class="md-button btn md-primary md-theme-default w-100 md-yellow" :disabled="isLoading" @click="submit">{{ i18n.lbl_got_it() }}
          <md-tooltip md-direction="bottom">{{ i18n.lbl_delete_notif() }}</md-tooltip>
        </md-button>
       </md-dialog-actions>
    </md-dialog>
</template>

<script>
import Detail from '@vue/app/common/Detail.Row'
import { i18n } from '@js/i18n'
import { mapActions } from 'vuex'
import CurrencyRound from '@com/mixins/currency.round.mixin'
import { CRYPTO_CURRENCYS } from '@utils/consts'
export default {
  name: 'LymitDialog',
  components: { Detail },
  mixins: [CurrencyRound],
  data () {
    return {
      isLoading: false,
      i18n,
      CRYPTO_CURRENCYS
    }
  },
  props: {
    active: {
      type: Boolean,
      default: false
    },
    values: {
      type: Object,
      required: true
    },
    padding: {
      type: Boolean,
      default: true
    }
  },
  emits: ['close'],
  methods: {
    ...mapActions({
      deleteNotificationById: 'deleteNotificationById'
    }),
    async submit () {
      try {
        this.isLoading = true
        await this.deleteNotificationById(this.values)
        this.isLoading = false
      } catch (err) {
        console.log(err)
      } finally {
        this.$emit('close')
      }
    }
  },
  computed: {
    amount () {
      if (this.values.amount) {
        const num = this.values.asset === this.CRYPTO_CURRENCYS.USDTBEP ? Number(this.values.amount) / 1000000000000000000 : Number(this.values.amount) / 1000000
        return this.roundCurrency3(num, this.values.asset)
      }
    },
    orderAmount () {
      if (this.values.order_amount) {
        return `${this.roundCurrency3(this.values.order_amount)} ${this.values.order_currency}`
      }
      return false
    }
  }
}
</script>

<style scoped lang="scss">
.w-100 {
  width: 100%;
}
/deep/ .md-title {
  padding: 0;
}
.custom-padding {
  padding-right: 56px !important;
}
</style>



// WEBPACK FOOTER //
// src/vue/navigation/LymitDialog.vue